<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 32 32"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <circle
      cx="11"
      cy="12"
      r="3.6"
      fill="currentColor"
      stroke="none"
    />
    <circle
      cx="21"
      cy="12"
      r="3.6"
      fill="currentColor"
      fill-opacity=".5"
      stroke="currentColor"
    />
    <path
      d="M4 24c0-4 3-6 7-6s4 2 5 3"
      fill="none"
    />
    <path
      d="M28 24c0-4-3-6-7-6s-4 2-5 3"
      fill="none"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconIntentFriendship',
  props: { size: { type: [String, Number], default: 22 } },
};
</script>
